<template>
  <div :class="['voucher']">
    <slot name="main">
      <div class="main">${{ amount }}</div>
    </slot>
    <slot name="footer">
      <div class="footer">{{ footerText }}</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'voucher',
  props: ['type', 'amount', 'footerText']
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/voucher.scss';
</style>
